export const CRIBL_AGENT_HEADER_NAME = 'X-Cribl-Agent';
export const CRIBL_SOURCE_HEADER_NAME = 'X-Cribl-Source';
export const MAESTRO_AGENT = 'maestro';
export const TYPHON_AGENT = 'typhon';
export const ORG_LEADER_AGENT = 'org-leader';
